'use client';
import { createContext, useContext, useState } from 'react';

interface IFormContext {
  handleFieldChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  removeFile: (f: File) => void;
  data: FormValues;
  setData: (value: FormValues) => void;
  resetForm: () => void;
  handleDroppedFiles: (target: keyof FormValues, file: File[]) => void;
}

export interface SocialMediaInfoType {
  platform: Platforms | undefined; //socialMediaPlatform,
  url: string; // socialMediaUrl
}

export enum Platforms {
  'Bitchute' = 'Bitchute',
  'Bluesky' = 'Bluesky',
  'Clubhouse' = 'Clubhouse',
  'Facebook' = 'Facebook',
  'Gab' = 'Gab',
  'Instagram' = 'Instagram',
  'LinkedIn' = 'LinkedIn',
  'Pinterest' = 'Pinterest',
  'Poshmark' = 'Poshmark',
  'Quora' = 'Quora',
  'Reddit' = 'Reddit',
  'Rumble' = 'Rumble',
  'Soundcloud' = 'Soundcloud',
  'Threads' = 'Threads',
  'Tiktok' = 'Tiktok',
  'TruthSocial' = 'TruthSocial',
  'Tumblr' = 'Tumblr',
  'X/Twitter' = 'X/Twitter',
  'Wayup' = 'Wayup',
  'YouTube' = 'YouTube'
}

export interface EventMediaType {
  eventFootage: File[],
  mediaSource: string;
  eventDate: string;
  location: string;
  description: string;
}

export interface FormValues {
  firstName: string; //First Name*
  middleName: string; // Middle Name
  lastName: string; // Last Name*
  representativePhoto: File[]; // Representative photo*
  university: string; // University
  citizenship: string;
  professionalTitle: undefined | ProfessionalTitleOptions; // Professional Title
  biographicalURL: string; // URL to confirm Biographical info*
  socialMediaInfo: SocialMediaInfoType[];
  eventMedia: EventMediaType[]
  postURLs: string[]; //socialMediaPosts
  email: string; //contactPage
  username?: string;
  password?: string;
  phone?: string;
}

export enum ProfessionalTitleOptions {
  Student = 'Student',
  Professor = 'Professor',
  Medical = 'Medical Professional',
  Other = 'Other',
}

const FormContext = createContext<IFormContext | null>(null);

//@ts-expect-error payload
export const FormProvider = ({ children }) => {

  const initialState = {
    firstName: '',
    middleName: '',
    lastName: '',
    representativePhoto: [],
    university: '',
    citizenship: '',
    professionalTitle: undefined,
    biographicalURL: '',
    socialMediaInfo: [{
      platform: undefined,
      url: '',
    }],
    eventMedia: [],
    postURLs: [],
    email: '',
  }

  const [data, setData] = useState<FormValues>(initialState)

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    })
  }

  const removeFile = (toRemove: File) => {
    const updatedList = data.representativePhoto.filter((item) => item !== toRemove);
    setData({
      ...data,
      representativePhoto: updatedList,
    });
  }

  const handleDroppedFiles = (target: keyof FormValues, files: File[]) => {
    if (!files || files.length === 0) return;
    setData(prevData => ({
      ...prevData,
      [target]: [...(prevData[target] || []), ...files],
    }));
  };



  const resetForm = () => {
    setData(initialState);
  }

  return (
    <FormContext.Provider
      value={{
        data,
        setData,
        handleFieldChange,
        removeFile,
        resetForm,
        handleDroppedFiles
      }}
    >
      {children}
    </FormContext.Provider>

  )
}

export const useFormContext = (): IFormContext => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useFormContext must be used within a FormProvider');
  }
  return context;
};
